module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAATCAYAAABGKffQAAAAjElEQVQokY3QQQ2DMBSA4a9cuBEkTAISKmESZgMF2JiUSUACEhZu3HYhywalbW+v+f6meaCd1puK07TT+sDcTutQwmF/+Yk74jZ2cxbXBuF3KAXheJELTjgXJPFVcIlTQRYfg6YAewxYsOT+3OO1j3Ebu/fVNk6Q9J6T8IRz8A+X4BfXQAi1EBrEGggfQXtVNrG3IHYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/right05.png
// module id = 5Ld2
// module chunks = 1